/** DWG conversion stepper: Reading -> Layers -> Sheets -> Drawing. */
const STEPS = [["reading", "Reading"], ["layers", "Layers"], ["sheets", "Sheets"], ["drawing", "Drawing"]];

export default function CadProgress({ step = "reading", pct = 0 }) {
  const cur = Math.max(0, STEPS.findIndex(([k]) => k === step));
  const width = Math.min(100, Math.max(2, pct));
  return (
    <div className="mt-4 text-left" data-testid="cad-progress" data-step={step} data-pct={Math.round(width)}>
      <div className="h-1.5 w-full overflow-hidden rounded-full bg-slate-200">
        <div className="h-full rounded-full bg-[#f97316] transition-[width] duration-700 ease-out" style={{ width: `${width}%` }} />
      </div>
      <ol className="mt-2 grid grid-cols-4 gap-1 font-mono text-[9px] uppercase tracking-widest">
        {STEPS.map(([k, label], i) => (
          <li key={k} data-testid={`cad-step-${k}`} className={`flex items-center gap-1 ${i < cur ? "text-emerald-600" : i === cur ? "text-[#f97316]" : "text-slate-300"}`}>
            <span className={`inline-block h-1.5 w-1.5 rounded-full ${i < cur ? "bg-emerald-500" : i === cur ? "animate-pulse bg-[#f97316]" : "bg-slate-300"}`} />
            {label}
          </li>
        ))}
      </ol>
      <div className="mt-1 text-right font-mono text-[10px] text-slate-400">{Math.round(width)}%</div>
    </div>
  );
}
